import React, { useEffect } from "react"
import gsap from "gsap"
import { Vector3 } from "three"
import { sphericalCoords } from "./sphericalCoords"
import { useCanvasStore } from "@state/canvasStore"

export const useCamera = () => {
  const cameraData = useCanvasStore((s) => s.cameraData)
  const setSpherical = useCanvasStore((s) => s.setSpherical)

  const cameraRef = React.useRef<any>(null)
  const controlsRef = React.useRef<any>(null)

  useEffect(() => {
    const logCam = () => {
      const camsstring = `${
        Math.round(cameraRef.current.position.x * 100) / 100
      }, ${Math.round(cameraRef.current.position.y * 100) / 100}, ${
        Math.round(cameraRef.current.position.z * 100) / 100
      }`

      navigator.clipboard.writeText(camsstring)
    }
    window.addEventListener("click", logCam)

    return () => {
      window.removeEventListener("click", logCam)
    }
  }, [])

  const onChange = (e: any) => {
    if (!cameraRef.current) return

    // console.log(cameraRef.current.position);

    const { azimuth, polar } = sphericalCoords(
      cameraRef.current.position,
      controlsRef.current.target,
    )

    // console.log(azimuth);
    setSpherical({ polar, azimuth })
  }

  React.useEffect(() => {
    if (!cameraData) return
    const duration = 2

    const controls = controlsRef.current

    const distance = cameraData.position.distanceTo(cameraRef.current.position)
    const targetChangeDistance = cameraData.target.distanceTo(controls.target)

    const combiendDistance = Math.max(distance, targetChangeDistance)

    if (distance < 0.1) return

    gsap.to(controls.target, {
      delay: 0.5,

      x: cameraData.target.x,
      y: cameraData.target.y,
      z: cameraData.target.z,
      duration: combiendDistance < 0.001 ? 0.01 : duration,
      ease: "power1.inOut",
    })

    gsap.to(cameraRef.current.position, {
      delay: 0.5,
      x: cameraData?.position.x * 1,
      y: cameraData?.position.y * 1,
      z: cameraData?.position.z * 1,
      duration: combiendDistance < 0.001 ? 0.01 : duration,
      ease: "power1.inOut",
      onUpdate: () => {
        controls.update()
      },
    })
  }, [cameraData])

  return {
    cameraRef,
    controlsRef,
    onChange,
    cameraData,
  }
}
